"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolutionItemSchema = void 0;
const zod_1 = require("zod");
exports.ResolutionItemSchema = zod_1.z.strictObject({
    width: zod_1.z.number(),
    height: zod_1.z.number(),
    framerate: zod_1.z.number().optional(),
});
